<template>
  <v-layout column fill-height align-center justify-center>
    <div class="text-center">
        <div class="text">{{state}}</div>
        <v-progress-circular
            :rotate="-90"
            :size="172"
            :width="5"
            :value="value"
            color="primary"
            >
            {{ value }}
        </v-progress-circular>
        <div class="text">{{text}}</div>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import { mixinReward } from '@/mixins'

export default {
  mixins: [ mixinReward ],
    props:["travelApplNo", "unitNo", "travelApplStepCd", "memberNo", "memberStepApplCnt"],
    data: ()=> ({
        state:'',
        interval: {},
        value: 0,
        text:''
    }),
    beforeDestroy () {
      clearInterval(this.interval)
    },
    mounted(){
        //뒤로가기 숨김
        // this.$root.$children[0].$refs.appBar.$refs.hide111.$el.style.display='none'

        // this.setApplResultMindWeather();
        this.state = "분석중...";
        this.text = "여행지원서를 분석하고 있습니다."
    //     this.interval = setInterval(() => {
    //         if (this.value === 100) {
    //             this.state = "분석완료";
    //             this.text = "결과를 확인해보세요~!"
    //         }else{
    //             this.value += 10;
    //         }

    //   }, 3000);
        this.start()
    },
    methods:{
        result(){
            this.$emit('result');
        },
        async setApplResultMindWeather () { // 다음 버튼 클릭 시 현재 값을 저장함.
          const {trialStatus, expiredTrialTicket} = store.state.client.contract;
          let dispatchType = "setApplResultMindWeather"
          const readyTrial = (trialStatus === "JOIN" && !expiredTrialTicket);
          if (readyTrial) {
            dispatchType = "setTrialApplResultMindWeather";
          }
          await store.dispatch(dispatchType, this.$_payload('so',{
                  memberNo: this.memberNo,
                  unitNo: this.unitNo,
                  travelApplNo: this.travelApplNo,
                  travelApplStepCd: this.travelApplStepCd,
                  memberStepApplCnt: this.memberStepApplCnt
              }))
              .then(res => {
              if (res.success) {
                  if (readyTrial) {
                    store.dispatch('getContractedGoodsInfo')
                  }
                  if (this.travelApplStepCd == '0001') {
                      this.value += 10
                      this.reStart()
                      // this.insertUserSolution();
                  } else {

                      if(this.travelApplStepCd == "0002"){
                          // 중간 검사 코인획득
                        this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 10, '0002', store.getters.useOrdDtl.ordDtlNo)
                          // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', this.$store.state.auth.authUser.userKey, 10, '0002', store.getters.useOrdDtl.ordDtlNo)

                      }else if(this.travelApplStepCd == "0003"){
                          // 사후 검사 코인획득
                        this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 10, '0003', store.getters.useOrdDtl.ordDtlNo)
                          // this.$root.$children[0].$refs.content.$emit('insertMemberCoin', this.$store.state.auth.authUser.userKey, 10, '0003', store.getters.useOrdDtl.ordDtlNo)
                      }
                      clearInterval(this.interval);
                      setTimeout(() => {this.result()}, 500);
                  }
              } else {
                  console.log(res.msg);
              }
              })
              .catch(error => {
              console.error(error)
              })
              .finally(() => {
              })
        },
        start(){
            // 4초에 한번씩 start 호출
            this.interval = setInterval( () =>{
                if (this.value === 0) {
                    this.setApplResultMindWeather()
                    this.timeStop()
                }else if(this.value === 10){
                    // this.insertUserSolution()
                    // this.value += 10
                   this.value = 90
                   this.reStart()
                }else if(this.value === 80){
                    this.timeStop()
                }else if(this.value === 100){
                    this.state = "분석완료";
                    this.text = "결과를 확인해보세요~!"
                    clearInterval(this.interval);
                    setTimeout(() => {this.result()}, 1000);
                }else{
                    this.value += 10
                }
            },4000)
        },
        timeStop() {
            clearInterval(this.interval)
        },
        // 재실행
        reStart() {
            clearInterval(this.interval)
            this.start()
        },
    }
}
</script>

<style lang="scss" scoped>
.text{
    font-size:18px;
    font-weight: 400;
    color: #101010;
}
::v-deep.v-progress-circular{
    margin: 92px 0 28px 0;
    .v-progress-circular__underlay{
        stroke:#E9E6FF;
    }
    .v-progress-circular__info{
        font-size: 20px;
        font-weight: 700;
        color: #000;
        &:after{
            content: '%';
        }
    }

}
</style>
